import request from './request';

export const fileCategoryApi = {
  // 获取所有文件分类
  getList: () => request.get('/file-categories'),
  
  // 获取单个分类
  getById: (id) => request.get(`/file-categories/${id}`),
  
  // 创建分类（管理员）
  create: (data) => request.post('/file-categories', data),
  
  // 更新分类（管理员）
  update: (id, data) => request.put(`/file-categories/${id}`, data),
  
  // 删除分类（管理员）
  delete: (id) => request.delete(`/file-categories/${id}`)
};

export default fileCategoryApi;